export default __webpack_public_path__ + "static/media/moedas_k_mb.4ba11ccb.png";